<div id="sidebar" [class.w-65]="!collapsed" [class.w-20]="collapsed"
  class="sidebar fixed top-0 left-0 h-full bg-secondary py-5 flex flex-col z-50 transition-all duration-300 ease-in-out shadow-lg">
  <div class="">
    <!-- Toggle Button -->
    <button (click)="toggleSidebar()"
      class="absolute -right-3 top-6 bg-primary w-6 h-6 rounded-full flex items-center justify-center text-white shadow-lg md:hidden">
      <i class="fas" [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
    </button>

    <div class="logo flex items-center px-5 pb-5">
      <div class="logo-icon w-8 h-8">
        <img src="./Elan-glam.png" class="rounded-lg" />
      </div>
      <h1 class="text-xl font-semibold ml-2 transition-all duration-300"
        [ngClass]="{ 'opacity-0 hidden w-0 overflow-hidden': collapsed }">
        ELAN glam
      </h1>
    </div>

    <ul class="relative nav h-[calc(100vh-190px)] overflow-x-auto sidebar-scroll">
      <li
        class="nav-item px-5 py-3 mb-1 flex items-center transition-all duration-300 cursor-pointer mx-2 rounded-xl hover:bg-bg gap-2"
        routerLinkActive="bg-bg" [routerLink]="['/user/dashboard']">
        <span class="nav-icon mr-1 w-6 text-center"><i class="fa-solid fa-border-all"></i></span>
        <span class="nav-text white space-nowrap transition-all duration-300"
          [ngClass]="{ 'opacity-0 w-0 overflow-hidden': collapsed }">Dashboard</span>
      </li>
      <!-- <li *ngFor="let group of dropdowns" class="dropdown-group" [routerLinkActive]="['bg-bg']"> -->
      <li *ngFor="let group of getVisibleMenus()" class="dropdown-group">
        <!-- If it's a link -->
        <div *ngIf="group.link"
          class="dropdown-toggle flex items-center justify-between px-5 py-3 mb-1 transition-all duration-300 cursor-pointer mx-2 rounded-xl bg-bg hover:bg-bg"
          [routerLink]="[group.link]" [routerLinkActive]="['bg-bg']">
          <div class="flex items-center gap-2">
            <span class="nav-icon mr-1 text-lg w-6 text-center"><i [class]="group.icon"></i></span>
            <span class="nav-text white space-nowrap transition-all duration-300"
              [ngClass]="{ 'opacity-0 hidden w-0 overflow-hidden': collapsed }">
              {{ group.title }}
            </span>
          </div>
        </div>

        <!-- If it's a dropdown -->
        <ng-container *ngIf="!group.link">
          <div
            class="dropdown-toggle flex items-center justify-between px-5 py-3 mb-1 transition-all duration-300 cursor-pointer mx-2 rounded-xl hover:bg-bg"
            (click)="toggleDropdown(group)">
            <div class="flex items-center gap-2">
              <span class="nav-icon mr-1 text-lg w-6 text-center"><i [class]="group.icon"></i></span>
              <span class="nav-text whitespace-nowrap transition-all duration-300"
                [ngClass]="{ 'opacity-0 hidden w-0 overflow-hidden': collapsed }">
                {{ group.title }}
              </span>
            </div>
            <i class="fas fa-chevron-down text-xs dropdown-arrow transition-all"
              [ngClass]="{ 'rotate-180': group.open, 'opacity-0': collapsed }"></i>
          </div>

          <div class="dropdown-content" *ngIf="group.open && !collapsed">
            <a *ngFor="let item of group.items" href="#"
              class="block px-5 pl-[65px] py-2 text-sm text-text hover:text-white hover:bg-bg transition-all duration-300">
              {{ item }}
            </a>
          </div>
        </ng-container>
      </li>
      </ul>

      <div class="relative h-[100px]">
      <ul>
      <li *ngIf="canAccessSettings()"
        class="absolute bottom-[52px] w-[calc(100%-1.5rem)] nav-item px-5 py-3 mb-1 flex items-center transition-all duration-300 cursor-pointer mx-2 rounded-xl hover:bg-bg"
        routerLinkActive="bg-bg" [routerLink]="['/user/settings']">
        <span class="nav-icon mr-1 text-lg w-6 text-center"><i class="fas fa-cog"></i></span>
        <span class="nav-text">Settings</span>
      </li>
      <li
        class="absolute bottom-0 w-[calc(100%-1.5rem)] nav-item px-5 py-3 flex items-center transition-all duration-300 cursor-pointer mx-2 rounded-xl hover:bg-bg"
        (click)="userLogout()">
        <span class="nav-icon mr-1 text-lg w-6 text-center"><i class="fas fa-sign-out-alt"></i></span>
        <span class="nav-text">Logout</span>
      </li>
    </ul>
    </div>
  </div>
</div>